module.exports = __webpack_public_path__ + "static/img/support-wl.53373b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/support-wl.png
// module id = 442
// module chunks = 1